import { render, staticRenderFns } from "./addTrafficProductDialog.vue?vue&type=template&id=21b6d87f"
import script from "./addTrafficProductDialog.vue?vue&type=script&lang=js"
export * from "./addTrafficProductDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21b6d87f')) {
      api.createRecord('21b6d87f', component.options)
    } else {
      api.reload('21b6d87f', component.options)
    }
    module.hot.accept("./addTrafficProductDialog.vue?vue&type=template&id=21b6d87f", function () {
      api.rerender('21b6d87f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plan/rightPopup/stockPage/addProductDialog/addTrafficProductDialog.vue"
export default component.exports